import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { ArticlePath, createGuideLink, RouteName, TextKey } from '@mews-commander/enums';
import { checkEnterprisePrivilege } from '@mews-commander/legacy-entities';
import { LoadableMarketplaceContainer } from '@mews-commander/modules/src/modules/marketplace';
import { MewsTeam, RouteType } from '@mews/enums';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/EnterpriseIntegration/Marketplace')({
    validateSearch: z.object({
        OwnerId: z.string().uuid(),
        ActiveTabId: z.string().optional(),
        ApplicationId: z.string().optional(),
        CategoryId: z.string().optional(),
        SearchTerm: z.string().optional(),
    }),
    beforeLoad: ({ search: { OwnerId }, context: { getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED } }) => {
        if (!checkEnterprisePrivilege(getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED(), { enterpriseId: OwnerId })) {
            throw notFound();
        }
    },
    component: Component,
    staticData: {
        title: TextKey.Marketplace,
        routeName: RouteName.EnterpriseIntegrationMarketplace,
        owner: MewsTeam.ActivationExperience,
        type: RouteType.Frontend,
        guideLink: createGuideLink(ArticlePath.ConnectDisconnectIntegrations),
    },
});

function Component() {
    const { ApplicationId, CategoryId, SearchTerm, OwnerId } = Route.useSearch();

    return (
        <LoadableMarketplaceContainer
            applicationId={ApplicationId}
            categoryId={CategoryId}
            searchTerm={SearchTerm}
            enterpriseId={OwnerId}
        />
    );
}
